import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { PageType } from 'enums';
import { createFetchPageAction } from 'common/page/actions';
import pageSelector from 'common/selectors/pageSelector';
import heroSelector from 'common/selectors/heroSelector';
import BucketListContainer from './buckets/BucketListContainer';
import MainContainer from './common/MainContainer';
import SuperHero from './hero/SuperHero';
import playable from '@alias/Playable';
import { isEmpty } from 'lib/util';

const PlayableSuperHero = playable(SuperHero);

export const Catalog = ({ page, hero }) => {
    const {
        header: {
            name = '',
            description = '',
            subtitle = '',
            subtitleTwo = '',
            backgroundImage = {},
            image = {},
            logoImage = {}
        } = {},
        buckets = []
    } = page;
    const bannerAd = null; // [<BannerAd key="banner_ad" />];
    const bucket = buckets[0] || {};
    const bucketId = (bucket.metadata && bucket.metadata.bucketId) || bucket.id;
    const bucketName = bucket.name;
    const superHero = (!isEmpty(hero) && (hero.streams && hero.streams.length)) ? (
        <PlayableSuperHero
            name={name}
            description={description}
            subtitle={subtitle}
            director={subtitleTwo}
            image={backgroundImage.href}
            content={hero}
            bucketId={bucketId}
            bucketName={bucketName}
        />
    ) : (
        <SuperHero
            name={name}
            description={description}
            subtitle={subtitle}
            director={subtitleTwo}
            image={backgroundImage.href}
            icon={image.href}
            logoImage={logoImage.href}
        />
    );
    return (
        <MainContainer className="watch-home" pre={bannerAd}>
            <div className="layout-full layout-full--watch">
                <section className="col-a">
                    {superHero}
                    <BucketListContainer
                        key="bucket_list_container"
                        renderHeroInBucket
                        hideHeaderLink
                        pageType={PageType.CATALOG}
                    />
                </section>
            </div>
        </MainContainer>
    );
};

Catalog.propTypes = {
    page: PropTypes.object,
    hero: PropTypes.object
};

const mapStateToProps = (state) => ({
    page: pageSelector(state),
    hero: heroSelector(state)
});

Catalog.loadActions = [
    (params, query, lang) => {
        const { pageName, ...restOfParams } = params;
        return createFetchPageAction(pageName, restOfParams, query, lang);
    }
];

export default connect(mapStateToProps)(Catalog);



// WEBPACK FOOTER //
// ./app/common/page/Catalog.js